// extracted by mini-css-extract-plugin
module.exports = {"alert":"styles-module__alert___1bQyu","close-button":"styles-module__close-button___3YPdh"};